export const limitOptionsSelect = [
    {value: 15, label: '15'},
    {value: 50, label: '50'},
    {value: 100, label: '100'}
]

